import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
/**
 * Componentes
 */
//Componente que contiene los elementos del Header del sitio
import Header from '../components/header';
//Componente que indica el usuario que se encuentra logeado
import UserTop from '../components/userTop';
//Componente que contiene la infrmación de pacientes pendientes de alta
import PacientesPendientes from '../components/pacientesSection';
//Componente que contiene los elementos del Footer del sitio
import Footer from '../components/footer';
import SelectorImagen from '../components/selectorImagen';
import AsociadoForm from '../components/asociadoForm';
import CredentialViewer from '../components/credentialViewer';

/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, surgeryroomCollection } from '../../firebase/config';
import Usuarios from '../components/usuariosSection';

/**
 * Page asignada al control de pacientes pendientes de salida de quirófano
 * @param {Object} param0 Recibe los objetos necesarios para guardar la información de sesión
 * @returns Component Devuelve el sitio con los elementos y funcionalidad asignada
 */
const PacientesSalidaQuirofano = ({userName,userNomHospital,userLevel,uhList,access,padronList}) => {

    //Estado que indica que se esta solicitando información al servicio
    const [isLoader,setIsLoader] = useState(false)
    //Estado que almacena si esta activa la opción pacientes del menu
    const [isMostrarPacientes,setIsMostrarPacientes] = useState(true)
    //Estado que almacena si esta activa la opción pacientes del menu
    const [isMostrarRecuperacion,setIsMostrarRecuperacion] = useState(false)
    //Estado que almacena si esta activa la opción usuarios del menu
    const [isMostrarUsuarios,setIsMostrarUsuarios] = useState(false)
    //Estado que almacena si esta activa la opción usuarios del menu
    const [isMostrarNuevo,setIsMostrarNuevo] = useState(false)
    //Estado que almacena si esta activa la opción usuarios del menu
    const [isMostrarCredencial,setIsMostrarCredencial] = useState(false)
    //Estado que almacena los pacientes obtenidos desde la base de datos en una lista
    const [pacientesList,setPacientesList] = useState([])
    //Estado que almacena el nombre de la opción que ha elegido el usuario para utilizarse en la permanencia
    const [pageActive,setPageActive] = useState(sessionStorage.getItem('active'))
    //Estado que almacena la cantidad total de pacientes en quirófano
    const [totalQuirofano,setTotalQuirofano] = useState(0)
    //Estado que almacena la cantidad total de pacientes en recuperación
    const [totalRecuperacion,setTotalRecuperacion] = useState(0)
    const [asociado,setAsociado] = useState({})
    const [documentoSeleccionado,setDocumentoSeleccionado] = useState("")
    //Estado que almacena si esta activa la opción pacientes del menu
    const [isMostrarAdministradores,setIsMostrarAdministradores] = useState(true)
    const [isReadOnly, setIsReadOnly] = useState(false)

    useEffect(()=>{
        setIsLoader(true)
        pacientesStore.collection(surgeryroomCollection)
        .onSnapshot(snap => {
            const pacientes = []
            snap.forEach(doc => {
                pacientes.push({ id: doc.id, ...doc.data() })
            })
            console.log(pacientes)
            
            //inicio
            let cantidadPacientesQuirofano = 0
            let cantidadPacientesRecuperacion = 0
            let pacientesValidos = 0
            pacientes.forEach(
                    paciente => {
                        if(userLevel === "superuser"){
                            pacientesValidos++
                            if(paciente.active){
                                cantidadPacientesQuirofano++
                            }
                            else{
                                cantidadPacientesRecuperacion++
                            }
                        }
                        else{//usuario normal
                            if(userNomHospital === paciente.hospital){
                                pacientesValidos++
                                if(paciente.active){
                                    cantidadPacientesQuirofano++
                                }
                                else{
                                    cantidadPacientesRecuperacion++
                                }
                            }
                            else{
                                if(userNomHospital === "MAC Aguascalientes Sur" || userNomHospital === "MAC Aguascalientes Norte"){
                                    if(paciente.hospital === "MAC Aguascalientes Sur" || paciente.hospital === "MAC Aguascalientes Norte"){
                                        pacientesValidos++
                                        if(paciente.active){
                                            cantidadPacientesQuirofano++
                                        }
                                        else{
                                            cantidadPacientesRecuperacion++
                                        }
                                    }
                                }
                            }
                        }
                    }
                )

            
            if(pacientesValidos > 0){//Se verifica si existen pacientes que pertenezcan a la unidad hospitalaria requerida
                //setCantidadPacientes(pacientesValidos)
                setTotalQuirofano(cantidadPacientesQuirofano)
                setTotalRecuperacion(cantidadPacientesRecuperacion)
                
            }
            else{//No se encientraron pacientes pertenecientes a la unidad hospitalaria
                setTotalQuirofano(0)
                setTotalRecuperacion(0)
            }
            //fin

            if(localStorage.getItem("almacenamiento")){//Se verifica si se cuenta con registro de los pacientes que ha visualizado el usuario logeado
                //Se obtiene el array con los pacientes que ya ha visualizado el usuario
                let pacientesEnMemoria = JSON.parse(localStorage.getItem('almacenamiento'))
                /**
                 * Función que muestra si hay nuevos pacientes disponibles en el sistema
                 * @param {Array} originalArray Recibe los pacientes que ya han sido visualizado por el usuario logeado
                 * @param {Array} nuevoArray Recibe los pacientes obtenidos en la coleccion de surgeryroom
                 * @returns Boolean Devuelve si ha encontrado nuevos pacientes
                 */
                const hadNewPatient = (originalArray,nuevoArray) => {
                    nuevoArray.forEach(paciente => {
                        //Se busca si en el array de memoria se encuentran los elementos del arrar de la colección surgeryroom
                        const resultado = originalArray.find( pacienteOriginal => pacienteOriginal.id === paciente.id );
                        if(!resultado){//Se verifica si no se ha encontrado el paciente de la coleccion surgeryroom en la memoria
                            //audioEl.play()
                            Swal.fire({
                                icon:"warning",
                                title:"Atención!",
                                confirmButtonText: "Aceptar",
                                confirmButtonColor: "#04afaa",
                                text:"Nuevos socios disponibles.",
                                allowOutsideClick:false,
                              })
                              .then((res)=>{
                                if(res.isConfirmed){
            
                                }
                              })
                            return true
                        }
                    })
                    return false
                }
                hadNewPatient(pacientesEnMemoria,pacientes)
            }
            //Se guarda en memoria la nueva lista de pacientes
            try{
                localStorage.setItem("almacenamiento",JSON.stringify(pacientes))
            }
            catch{

            }
            
            setIsLoader(false)
            setPacientesList(pacientes)
        },(error)=>{
            setIsLoader(false)
            setPacientesList([])
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error,
              })
        })
    },[userNomHospital,userLevel,uhList])

    useEffect(()=>{
        if(pageActive){
            if(pageActive === "pacientes"){
                setIsMostrarPacientes(true)
            }
            else{
                setIsMostrarPacientes(false)
            }
        }
        else{
            if(userLevel === "recuperación"){
                setPageActive('recuperacion')
                sessionStorage.setItem('active','recuperacion')
                setIsMostrarRecuperacion(true)
            }
            else{
                setPageActive('pacientes')
                sessionStorage.setItem('active','pacientes')
            }
        }
    },[pageActive,userLevel])

    return(
        <>
            {/* <audio>
                <source src="https://assets.coderrocketfuel.com/pomodoro-times-up.mp3"></source>
            </audio> */}
            <div id="seccionCabeceraLogin" className='seccionCabeceraLogin'>
                <Header access={access} nomHospital={userNomHospital} name={userName} uhList={uhList} userLevel={userLevel}/>
                {
                    isMostrarNuevo || isMostrarCredencial
                        ?
                            null
                        :
                            <UserTop nomHospital={userNomHospital} name={userName} uhList={uhList} userLevel={userLevel} 
                            setIsMostrarPacientes={setIsMostrarPacientes} isMostrarPacientes={isMostrarPacientes}
                            setIsMostrarUsuarios={setIsMostrarUsuarios} isMostrarUsuarios={isMostrarUsuarios}
                            setIsMostrarRecuperacion={setIsMostrarRecuperacion} isMostrarRecuperacion={isMostrarRecuperacion}
                            totalQuirofano={totalQuirofano} totalRecuperacion={totalRecuperacion}
                            setIsMostrarAdministradores={setIsMostrarAdministradores} isMostrarAdministradores={isMostrarAdministradores}/>
                }
            </div>
            <br />
            <div className='cuerpoPacientes'>
            {
                isMostrarNuevo
                ?   
                    <AsociadoForm setIsMostrarNuevo={setIsMostrarNuevo} uhList={uhList} pacientesList={pacientesList} padronList={padronList}
                    userLevel={userLevel} nomHospital={userNomHospital}/>
                :
               isMostrarUsuarios
               ?
                    <SelectorImagen paciente={asociado} documentoSeleccionado={documentoSeleccionado} setIsMostrarUsuarios={setIsMostrarUsuarios} isReadOnly={isReadOnly}/>
               :
                isMostrarCredencial
                    ?
                        <CredentialViewer paciente={asociado} setIsMostrarCredencial={setIsMostrarCredencial}/>
                    :
                        isMostrarPacientes
                            ?
                            <PacientesPendientes nomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} name={userName} 
                                isMostrarPacientes={isMostrarPacientes} setTotalQuirofano={setTotalQuirofano} 
                                setTotalRecuperacion={setTotalRecuperacion} totalQuirofano={totalQuirofano}
                                isLoader={isLoader} pacientesList={pacientesList} padronList={padronList} 
                                setIsMostrarPacientes={setIsMostrarPacientes}
                                setIsMostrarUsuarios={setIsMostrarUsuarios}
                                setIsMostrarRecuperacion={setIsMostrarRecuperacion}
                                setAsociado={setAsociado}
                                setDocumentoSeleccionado={setDocumentoSeleccionado}
                                setIsMostrarNuevo={setIsMostrarNuevo}
                                setIsMostrarCredencial={setIsMostrarCredencial}
                                setIsReadOnly={setIsReadOnly}
                                isReadOnly={isReadOnly}/>
                            :
                                isMostrarRecuperacion
                                ? <PacientesPendientes nomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} 
                                    name={userName} isMostrarPacientes={isMostrarPacientes} setTotalQuirofano={setTotalQuirofano} 
                                    setTotalRecuperacion={setTotalRecuperacion} totalQuirofano={totalQuirofano}
                                    isLoader={isLoader} pacientesList={pacientesList} 
                                    setIsMostrarPacientes={setIsMostrarPacientes}
                                    setIsMostrarUsuarios={setIsMostrarUsuarios}
                                    setIsMostrarRecuperacion={setIsMostrarRecuperacion}
                                    setAsociado={setAsociado}
                                    setDocumentoSeleccionado={setDocumentoSeleccionado}
                                    setIsMostrarNuevo={setIsMostrarNuevo}
                                    setIsMostrarCredencial={setIsMostrarCredencial}
                                    setIsReadOnly={setIsReadOnly}
                                    isReadOnly={isReadOnly}/>
                                : 
                                    isMostrarAdministradores
                                        ?
                                            <Usuarios uhList={uhList} userLevel={userLevel} nomHospital={userNomHospital} setIsReadOnly={setIsReadOnly} isReadOnly={isReadOnly}/>
                                        :
                                            null
            }
            <Footer/>
            </div>
        </>
    )
}

export default PacientesSalidaQuirofano;